import { handleActions } from 'redux-actions';

import * as actions from 'actions/payout';

const initialState = {
  loading: false,
  error: null,
  balance: {},
};

const payout = handleActions(
  new Map([
    [
      actions.fetchBalanceActions.request,
      state => ({
        ...state,
        error: null,
        loading: true,
        balance: {},
      }),
    ],
    [
      actions.fetchBalanceActions.success,
      (state, action) => ({
        ...state,
        loading: false,
        error: null,
        balance: action.payload,
      }),
    ],
    [
      actions.fetchBalanceActions.error,
      (state, action) => ({
        ...state,
        loading: false,
        error: action.payload,
        balance: {},
      }),
    ],
  ]),
  initialState,
);

export default payout;
